import request from '@/http/request'

export const scanResult = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid-postservice/grey_market/scan/result`, params, {
    hiddenError: true
  })
}

export const scanRecord = params => {
  return request.get(`${process.env.REACT_APP_RFID_API_URL}/rfid-postservice/grey_market/scan/record`)
}

export const scanRecordDetail = params => {
  return request.get(`${process.env.REACT_APP_RFID_API_URL}/rfid-postservice/grey_market/detail`, { params })
}

export const searchByEpc = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/grey_market/search/epc`, params)
}

export const searchByUpc = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/grey_market/search/upc`, params)
}

export const exportReport = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/grey_market/export`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}
